import { render, staticRenderFns } from "./JobEditPreviewMessageSent.vue?vue&type=template&id=4c20f607"
import script from "./JobEditPreviewMessageSent.vue?vue&type=script&lang=js"
export * from "./JobEditPreviewMessageSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports